/* eslint-disable require-jsdoc */
import $ from 'jquery';
import { debug } from '../../config';
import {getAjaxOpts} from './ajaxLogic';

async function getAjax(url, auth) {
  let result;
  const opts = getAjaxOpts(url, 'GET', auth);
  await $.ajax(opts)
      .done(function(data) {
        debug && console.log(data);
        result = data;
      })
      .fail(function(xhr, status, error) {
      // Ajax request failed.
        const errorMessage = xhr.status + ': ' + xhr.statusText;
        debug && console.log('errorMessage');
      });

  // let result;
  // try {
  //   result = await $.ajax({
  //     url: args,
  //     type: 'GET',
  //   });
  //   return result;
  // } catch (error) {
  //   console.error(error);
  // }
  return result;
}

export {getAjax};
